const KEY_PREFIX = 'mini_tasks_pattern_recognition_round:';

export function patternRecognitionStorageKey(roundId) {
  return `${KEY_PREFIX}${roundId}`;
}

export function readPatternRecognitionProgress(roundId, boardSessionId) {
  try {
    const raw = window.localStorage.getItem(patternRecognitionStorageKey(roundId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (String(parsed?.board_session_id || '') !== String(boardSessionId || '')) return null;
    if (String(parsed?.round_id || '') !== String(roundId || '')) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function writePatternRecognitionProgress(roundId, progress) {
  try {
    window.localStorage.setItem(patternRecognitionStorageKey(roundId), JSON.stringify({
      ...progress,
      round_id: roundId,
      updated_at: new Date().toISOString(),
    }));
  } catch (_) {
    // The active React state remains usable when storage is unavailable.
  }
}

export function clearPatternRecognitionProgress(roundId) {
  try {
    window.localStorage.removeItem(patternRecognitionStorageKey(roundId));
  } catch (_) {
    // Ignore storage failures after a successful completion.
  }
}
